import { render, staticRenderFns } from "./SetupNewAccountPage.vue?vue&type=template&id=11ee4ef2&"
import script from "./SetupNewAccountPage.vue?vue&type=script&lang=js&"
export * from "./SetupNewAccountPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports